import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { TicketIcon, ChevronRightIcon } from '@heroicons/react/outline'

class UpcomingBookingsCard extends Component {
	_formatTime = (ts) => {
		const d = new Date(ts * 1000)
		let h = d.getHours()
		let m = d.getMinutes()
		if (h < 10) h = '0' + h
		if (m < 10) m = '0' + m
		return h + 'h' + m
	}

	_formatDay = (ts) => {
		const days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']
		const months = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.']
		const d = new Date(ts * 1000)
		const today = new Date()
		const tomorrow = new Date()
		tomorrow.setDate(today.getDate() + 1)
		if (d.toDateString() === today.toDateString())
			return "Aujourd'hui"
		if (d.toDateString() === tomorrow.toDateString())
			return 'Demain'
		return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]
	}

	_getBenefitName = (bid) => {
		const benefits = this.props.benefits || []
		const lang = this.props.langDefault || 'fr'
		for (let i = 0; i < benefits.length; i++)
		{
			if (String(benefits[i]._id) !== String(bid)) continue
			const translations = benefits[i].translations || []
			for (let j = 0; j < translations.length; j++)
			{
				if (translations[j].lang === lang)
					return translations[j].name || translations[j].title || translations[j].subtitle || null
			}
			if (translations.length > 0)
				return translations[0].name || translations[0].title || translations[0].subtitle || null
		}
		return null
	}

	_buildSlots = () => {
		const now = Math.round(Date.now() / 1000)
		const reservations = this.props.reservations || []
		const map = {}
		const order = []
		for (let i = 0; i < reservations.length; i++)
		{
			const r = reservations[i]
			if (r.start <= now) continue
			if (r.cancelled === true) continue
			if (r.cart && r.cart.length > 0) continue
			const bid = (r.service_benefit && r.service_benefit._id) ? String(r.service_benefit._id) : String(r.service_benefit || '')
			const key = (bid || 'none') + '_' + r.start
			if (!map[key])
			{
				map[key] = {
					key: key,
					start: r.start,
					benefitName: this._getBenefitName(bid) || 'Activité',
					count: 0
				}
				order.push(key)
			}
			map[key].count++
		}
		return order.map(k => map[k]).sort((a, b) => a.start - b.start)
	}

	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
					<div className="h-3 bg-slate-200 rounded-full w-1/3 mb-4"></div>
					<div className="h-4 bg-slate-100 rounded mb-2"></div>
					<div className="h-4 bg-slate-100 rounded w-3/4 mb-2"></div>
					<div className="h-4 bg-slate-100 rounded w-1/2"></div>
				</div>
			)
		}
		if (this.props.error === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Inscriptions à venir</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						Réessayer
					</button>
				</div>
			)
		}
		const slots = this._buildSlots()
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
				<div className="flex items-center justify-between px-5 pt-5 pb-3">
					<div>
						<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Inscriptions à venir</h2>
						{slots.length > 0 &&
							<p className="text-2xl font-black text-slate-900 mt-1 mb-0 leading-none">
								{slots.length} <span className="text-sm font-bold text-slate-400">créneau{slots.length > 1 ? 'x' : ''}</span>
							</p>
						}
					</div>
					<Link to="/services/booking" className="group flex items-center gap-1 text-2xs font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-800 cursor-pointer transition-colors whitespace-nowrap">
						Voir tout
						<ChevronRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
					</Link>
				</div>
				{slots.length === 0 &&
					<div className="flex items-center gap-3 px-5 pb-5">
						<div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
							<TicketIcon className="w-5 h-5 text-slate-400" aria-hidden="true" />
						</div>
						<p className="text-sm font-medium text-slate-500 my-0">Aucune inscription dans les 7 prochains jours.</p>
					</div>
				}
				{slots.length > 0 &&
					<>
						<div>
							{slots.slice(0, 5).map(slot => {
								return (
									<div key={slot.key} className="flex items-center gap-3 px-5 py-2.5 border-t border-slate-100">
										<div className="flex-shrink-0 text-center" style={{ minWidth: '52px' }}>
											<span className="text-2xs font-bold text-slate-400 block leading-none">{this._formatDay(slot.start)}</span>
											<span className="text-xs font-black text-slate-900 bg-slate-100 rounded-lg px-2 py-1 inline-block mt-1">{this._formatTime(slot.start)}</span>
										</div>
										<span className="text-sm font-semibold text-slate-600 truncate flex-1">{slot.benefitName}</span>
										<span className="flex-shrink-0 text-xs font-black text-indigo-600 bg-indigo-50 rounded-lg px-2 py-1">
											{slot.count} inscrit{slot.count > 1 ? 's' : ''}
										</span>
									</div>
								)
							})}
						</div>
						{slots.length > 5 &&
							<p className="px-5 py-3 my-0 text-xs font-bold text-slate-400 border-t border-slate-100">
								+ {slots.length - 5} autre{slots.length - 5 > 1 ? 's' : ''} créneau{slots.length - 5 > 1 ? 'x' : ''}
							</p>
						}
					</>
				}
			</div>
		)
	}
}

export default UpcomingBookingsCard
